import styled from 'styled-components';
import { Dropdown as SemanticDropdown, DropdownItem } from 'semantic-ui-react';

export const Link = styled.a``;

export const NoResultsMessage = styled(DropdownItem)`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  width: 100%;
`;

export const Dropdown = styled(SemanticDropdown)`
  margin-top: 13px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')} !important;
  pointer-events: auto !important;
  &.ui.selection.dropdown>.dropdown.icon {
    ${({ disabled }) => (disabled ? 'cursor: not-allowed !important;' : '')}
`;
